import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import OwnListingLink from '../../components/OwnListingLink/OwnListingLink';
import affordability from './images/affordability.png';
import compatibility from './images/compatibility.png';
import flexibility from './images/flexibility.png';
import checked from './images/checked.png';
import matchingPic from './images/matchingPic.png';

import css from './SectionHowItWorks.module.css';

const SectionHowItWorks = props => {
  const { rootClassName, className, currentUserListing, currentUserListingFetched } = props;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <div className={css.firstTitle}>
        <FormattedMessage id="SectionHowItWorks.titleLineOne" />
        </div>
        
        <div className={css.secondTitle}>
        <FormattedMessage  id="SectionHowItWorks.titleLineTwo" />
        </div>
      </div>

      <div className={css.matchingSection}>
        
        <div className={css.matchingSectionLeft}>
          <div className={css.matchingSectionText}>
              <p>AppBuddy is an online platform that matches you to pre-screened students freelancing application services such as personal statement brainstorming, editing, mock interviews and consultations.
          </p>
          </div>

          <div className={css.checkboxes}>
              <ul className={css.leftSecUl1}>
                    <li>
                            <span><img className={css.checkedImage} src={checked}/>Dream schools </span>
                    </li>
                    <li>
                            <span><img className={css.checkedImage} src={checked}/>Gap year vs no gap year </span> 
                    </li>
                    <li>
                            <span><img className={css.checkedImage} src={checked}/>Budget </span>
                    </li>
              </ul>

              <ul className={css.leftSecUl2}>
                      <li>
                              <span><img className={css.checkedImage} src={checked}/>Research experience </span>
                      </li>
                      <li>
                              <span><img className={css.checkedImage} src={checked}/>Extracurricular activities </span>
                      </li>
                      <li>
                              <span><img className={css.checkedImage} src={checked}/>GPA & standardized tests </span>
                      </li>
              </ul>
              </div>

              {/* <div className={css.buttonWrapper}>
                <a href={`${typeof window === "undefined" ? "" : window.location.origin}/signup-helper`}>
                    <button className={css.getStartedButton}>Get started ></button>
                    </a>
              </div> */}
        </div>
        <div  className={css.matchingSectionRight}>
              <img src={matchingPic} className={css.matchingPic} />
        </div>

      </div>

      {/* <h2 className={css.getMatchedTitle}>Why AppBuddy?</h2>
      
      <div className={css.steps}>
        <div className={css.step}>
          <img className={css.stepImage} src={compatibility} />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionHowItWorks.part1Title" />
          </h2>
          <p>
            <FormattedMessage id="SectionHowItWorks.part1Text" />
          </p>
        </div>

        <div className={css.step}>
        <img className={css.stepImage} src={affordability} />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionHowItWorks.part2Title" />
          </h2>
          <p>
            <FormattedMessage id="SectionHowItWorks.part2Text" />
          </p>
        </div>

        <div className={css.step}>
        <img className={css.stepImage} src={flexibility} />
          <h2 className={css.stepTitle}>
            <FormattedMessage id="SectionHowItWorks.part3Title" />
          </h2>
          <p>
            <FormattedMessage id="SectionHowItWorks.part3Text" />
          </p>
        </div>
      </div> */}
      {/* <div className={css.createListingLink}>
        <OwnListingLink listing={currentUserListing} listingFetched={currentUserListingFetched}>
          <FormattedMessage id="SectionHowItWorks.createListingLink" />
        </OwnListingLink>
      </div> */}
    </div>
  );
};

SectionHowItWorks.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionHowItWorks.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionHowItWorks;
